module.exports = __webpack_public_path__ + "img/weather37.936b0ecd.png";